// change this to recolor every checkbox in the app
const checkedColor = '#f39c12';

const checkedStyle = {
    '&$checked': {
        color: checkedColor,
        '&:hover': {
            backgroundColor: 'rgba(243, 156, 18, 0.08)'
        }
    }
};

export default {
    colorPrimary: checkedStyle,
    colorSecondary: checkedStyle
};
